export type PreTriageSubmissionTransition = 'ignore-stale-response' | 'advance-after-revision-change' | 'initialize-live-triage-step' | 'advance-live-triage-step';

export interface DeterminePreTriageSubmissionTransitionRequest {
  submittedStepId: string;
  activeStepId: string | undefined;
  submittedJourneyRevision: number;
  nextJourneyRevision: number;
  isStoredNextStep: boolean;
  wouldAdvanceCreateCycle: boolean;
}

export class DeterminePreTriageSubmissionTransitionUseCase {
  public execute(request: DeterminePreTriageSubmissionTransitionRequest): PreTriageSubmissionTransition {
    if (request.activeStepId !== request.submittedStepId) {
      return 'ignore-stale-response';
    }

    // A step identity already held in the draft is a stored replay; only a new identity at a new revision means the back end invalidated the later branch.
    if (request.nextJourneyRevision !== request.submittedJourneyRevision && !request.isStoredNextStep) {
      return 'advance-after-revision-change';
    }

    if (request.wouldAdvanceCreateCycle) {
      return 'initialize-live-triage-step';
    }

    return 'advance-live-triage-step';
  }
}
